<txp-loading *ngIf="loading" [color]="loadingColor.COLOR"></txp-loading>

<mat-accordion
    [hidden]="loading"
    class="accordion"
    [multi]="true"
    [formGroup]="form"
    *ngIf="decoratorData">
    <mat-expansion-panel
        *ngFor="let key of decoratorData.keys; index as i"
        class="panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
              <txp-change-set-notice [itemChanges]="itemChanges" [customDecider]="hasLanguageChanges.bind(this, key)">
                {{key.label}}
                <span class='default-language'>{{ key.defaultLanguage ? ('brand.businessInfo.default' | translate)  : ''}} </span>
              </txp-change-set-notice>
            </mat-panel-title>
            <mat-panel-description class="panel-description">
                <span class="header-icon">
                    <txp-loading *ngIf="loading" [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
                    <i class="tce-icon-circle-check" *ngIf="!hasBlank(form.get(key.property).value, key.property)"></i>
                    <i class="tce-icon-circle-cross default-cross-icon" *ngIf="key.defaultLanguage && hasBlank(form.get(key.property).value, key.property)"></i>
                </span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div>
            <div *ngFor="let field of decoratorData.fields">
              <txp-change-set-notice
                [activeVersion]="selectedVersion"
                [itemChanges]="itemChanges"
                [customDecider]="hasDecoratorChanged.bind(this, field.property, key.property)"
                [noticeType]="'icon'"
                [eventDetail]="'decorators.' + key.property + '.' + field.property">
                <mat-form-field
                  [formGroup]="$any(form.get(key.property))"
                  class="field"
                  data-qa-label="LanguageFormField"
                  [ngClass]="fieldIsReadOnly(key, field.property) ? ('read-only code-' + key.property) : ''">
                    <mat-label>{{ field.label }}</mat-label>

                    <textarea *ngIf="field.property.includes('description') || forceTextArea"
                              data-qa-label="Input"
                              [readonly]="fieldIsReadOnly(key, field.property)"
                              [formControlName]="field.property"
                              [maxlength]="descriptionMaxLength || null"
                              [errorStateMatcher]="matcher"
                              matInput>
                    </textarea>
                    <input *ngIf="!field.property.includes('description') && !forceTextArea"
                        data-qa-label="Input"
                        [readonly]="fieldIsReadOnly(key, field.property)"
                        [formControlName]="field.property"
                        [maxlength]="titleMaxLength || null"
                        [errorStateMatcher]="matcher"
                        matInput/>
                    <mat-error *ngIf="$any(form.controls[key.property]).controls[field.property]?.errors?.whiteSpace">
                        {{ 'form.error.whiteSpaceNotAllowed' | translate }}
                    </mat-error>
                    <mat-error *ngIf="$any(form.controls[key.property]).controls[field.property]?.errors?.maxlength">
                        {{ 'form.error.maxLength' | translate:{value: $any(form.controls[key.property]).controls[field.property]?.errors?.maxlength?.requiredLength} }}
                    </mat-error>
                    <mat-hint *ngIf="(field.property.includes('description') || forceTextArea) && descriptionMaxLength && $any(form.controls[key.property]).controls[field.property]?.value?.length > (descriptionMaxLength -1)">
                        {{ 'form.error.maxLength' | translate:{value: descriptionMaxLength} }}
                    </mat-hint>
                    <mat-hint *ngIf="(!field.property.includes('description') && !forceTextArea) && titleMaxLength && $any(form.controls[key.property]).controls[field.property]?.value?.length > (titleMaxLength -1)">
                        {{ 'form.error.maxLength' | translate:{value: titleMaxLength} }}
                    </mat-hint>
                </mat-form-field>
              </txp-change-set-notice>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
